<template>
  <div class="container">
    <div class="item headers">
      <div class="notifications property">Property</div>
      <div class="notifications chore">Chore</div>
      <div class="notifications type">Type</div>
      <div class="notifications date">Date</div>
      <div class="notifications time">Time</div>
      <div class="notifications status">Status</div>
      <div class="notifications edit" />
      <div class="notifications delete" />
    </div>
    <section
      v-if="!all_notifications || all_notifications.length == 0"
      class="empty-notification-screen"
    >
      <img src="../../assets/no_notifications.svg" />
      <div>Add your first notification</div>
      <button @click="createNotification">New Notification</button>
    </section>
    <section v-else>
      <div
        v-for="(notification, uuid) in all_notifications"
        :key="uuid"
        class="item"
      >
        <div class="notifications property">
          {{ bindPropertyName(notification.propertyID) }}
        </div>
        <div class="notifications chore">
          {{ bindChoreName(notification.choreID) }}
        </div>
        <div class="notifications type">{{ notification.type }}</div>
        <div class="notifications date">
          {{ calculateDate(notification.dateOffset, notification.type) }}
        </div>
        <div class="notifications time">
          {{ formatTime(notification.time.hours) }}:{{
            formatTime(notification.time.minutes)
          }}
        </div>
        <div
          class="notifications status"
          @click="switchStatus(notification.uuid, notification.active)"
        >
          <img
            src="../../assets/notification_on.svg"
            alt="notification_on"
            v-if="notification.active"
            class="status"
          />
          <img
            src="../../assets/notification_off.svg"
            alt="notification_off"
            v-else
            class="status"
          />
        </div>
        <button class="notifications edit" @click="edit(notification)">
          <img src="../../assets/editIcon.svg" />
        </button>
        <button
          class="notifications delete"
          @click="showDeletePopupAction(true, notification.uuid)"
        >
          <img src="../../assets/deleteIcon.svg" />
        </button>
      </div>
    </section>
    <div v-if="showDeletePopup">
      <delete-popup
        @confirm="erase"
        @cancel="showDeletePopupAction(false, null)"
        :thingName="'Notification'"
      />
    </div>
  </div>
</template>

<script>
import calls from '../../api/calls'
import DeletePopup from '../GenericDeletePopup.vue'

export default {
  name: 'ListNotifications',
  components: {
    DeletePopup
  },
  data() {
    return {
      all_notifications: [],
      showDeletePopup: false,
      notificationID: null,
      properties: [],
      chores: []
    }
  },
  computed: {
    noNotifications() {
      return (
        this.all_notifications == null ||
        this.all_notifications == undefined ||
        this.all_notifications.length < 1
      )
    }
  },
  methods: {
    calculateDate(offset, type) {
      let date

      if (offset == 0 && type == 'reminder') date = 'Same day'
      else if (offset == 1 && type == 'reminder') date = '1 day before'
      else if (offset == 2 && type == 'reminder') date = '2 days before'
      else if (offset == 0 && type == 'schedule') date = 'Daily'
      else if (offset == 1 && type == 'schedule') date = 'Weekly'
      else if (offset == 2 && type == 'schedule') date = 'Every 2 weeks'

      return date
    },

    formatTime(time) {
      let format
      if (time < 10) format = '0' + time
      else format = time

      return format
    },

    bindPropertyName(value) {
      const propertyObject = this.properties.filter(
        (property) => property.uuid == value
      )
      return propertyObject[0]['name']
    },

    bindChoreName(value) {
      const choreObject = this.chores.filter((chore) => chore.uuid == value)
      return choreObject[0]['name']
    },
    createNotification() {
      this.$emit('loading', true)
      this.$router.push({ name: 'NewNotificationScreen' })
    },
    async switchStatus(id, status) {
      this.$emit('loading', true)
      try {
        if (status) {
          const { message } = await calls.PUT(`notifications/stop/${id}`)
          if (message) {
            this.$notify({
              group: 'rent-mgt-notification',
              type: 'error',
              text: message
            })
          }
        } else {
          const { message } = await calls.PUT(`notifications/start/${id}`)
          if (message) {
            this.$notify({
              group: 'rent-mgt-notification',
              type: 'error',
              text: message
            })
          }
        }
        await this.loadNotifications()
      } finally {
        this.$emit('loading', false)
      }
    },

    edit(notification) {
      this.$emit('loading', true)
      this.$router.push({
        name: 'NewNotificationScreen',
        params: { notification: notification }
      })
    },
    async erase() {
      this.$emit('loading', true)
      try {
        await calls.DELETE('notifications', `${this.notificationID}`)
        this.notificationID = null
        this.showDeletePopup = false
        await this.loadNotifications()
      } finally {
        this.$emit('loading', false)
      }
    },

    async showDeletePopupAction(value, notificationID) {
      this.showDeletePopup = value
      this.notificationID = notificationID
    },

    async loadProperties() {
      const { message, data } = await calls.GET('properties')
      this.properties = data
    },

    async loadChores() {
      const { message, data } = await calls.GET('chores')
      this.chores = data
    },

    async loadNotifications() {
      const { data } = await calls.GET('notifications/1/100')
      this.all_notifications = data
    }
  },
  async created() {
    this.$emit('loading', true)
    try {
      await this.loadChores()
      await this.loadProperties()
      await this.loadNotifications()
    } finally {
      this.$emit('loading', false)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.container {
  display: block;
  flex-direction: column;
  background-color: white;
  flex: 1;
  height: calc(95% - 24px);
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  min-height: 48px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  color: #192a3e;
  border-bottom: rgb(0, 0, 0, 0.1) 1px solid;
  background-color: white;
  min-width: 800px;
}

.item.headers {
  display: flex;
  color: #66b015;
  border: none;
  font-weight: bold;
  background-color: #ebf0e6;
  padding-left: 10px;
}

.notifications.property {
  padding-left: 1%;
}

.notifications {
  flex-basis: 14%;
}

.notifications.type {
  flex-basis: 14%;
}

.notifications.date {
  flex-basis: 14%;
}

.notifications.time {
  flex-basis: 14%;
}

.notifications .status {
  flex-basis: 8%;
  cursor: pointer;
}
.notifications.edit {
  flex-basis: 3%;
  border: none;
  background-color: white;
}
.notifications.delete {
  flex-basis: 3%;
  padding-right: 30px;
  border: none;
  background-color: white;
}

.notifications.edit:hover,
.notifications.delete:hover {
  cursor: pointer;
}

.empty-notification-screen {
  width: 100%;
  height: 70%;
  padding-top: 5%;
}

.empty-notification-screen img {
  width: 30%;
  height: 30%;
}

.empty-notification-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.empty-notification-screen button {
  background: #66b015;
  border-radius: 4px;
  border: none;
  color: white;
  font-family: Montserrat;
  font-size: 16px;
  height: 40px;
  width: 192px;
  cursor: pointer;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .container {
    padding: 0;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .item {
    width: 100%;
    min-width: 800px;
    max-width: none;
    padding: 12px 8px;
    height: auto;
    min-height: 56px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    box-sizing: border-box;
  }

  .item.headers {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #ebf0e6;
    padding: 16px 8px;
    font-size: 12px;
    font-weight: 700;
    width: 100%;
    min-width: 800px;
    max-width: none;
  }

  .notifications {
    flex: 1;
    padding: 4px 8px;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 24px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .notifications.property {
    flex: 2;
    padding-left: 8px;
    font-weight: 600;
    color: #333;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.type {
    flex: 1;
    font-weight: 600;
    color: #66b015;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.date,
  .notifications.time {
    flex: 1;
    font-size: 12px;
    color: #666;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.status {
    flex: 0 0 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    max-width: 60px;
  }

  .notifications.status img {
    width: 24px;
    height: 24px;
    transition: all 0.2s ease;
  }

  .notifications.status:hover img {
    transform: scale(1.1);
  }

  .notifications.edit,
  .notifications.delete {
    flex: 0 0 40px;
    padding: 8px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    max-width: 40px;
    min-height: 40px;
    margin-left: -20px;
  }

  .notifications.edit:hover,
  .notifications.delete:hover {
    background-color: #f8f9fa;
    border-radius: 4px;
    transform: scale(1.05);
  }

  .notifications.edit img,
  .notifications.delete img {
    width: 20px;
    height: 20px;
    opacity: 0.7;
    transition: opacity 0.2s ease;
  }

  .notifications.edit:hover img,
  .notifications.delete:hover img {
    opacity: 1;
  }

  /* Enhanced empty state for mobile */
  .empty-notification-screen {
    width: 100%;
    height: auto;
    padding: 40px 20px;
    text-align: center;
    background: white;
    border-radius: 8px;
    margin: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .empty-notification-screen img {
    width: 25%;
    height: auto;
    margin-bottom: 20px;
  }

  .empty-notification-screen div {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 20px;
    color: #666;
  }

  .empty-notification-screen button {
    width: 100%;
    max-width: 200px;
    height: 44px;
    font-size: 16px;
    border-radius: 6px;
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .empty-notification-screen button:hover {
    background: #5a9b12;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 176, 21, 0.3);
  }

  /* Mobile-specific touch improvements */
  .notifications.status:active,
  .notifications.edit:active,
  .notifications.delete:active {
    transform: scale(0.95);
  }

  .empty-notification-screen button:active {
    transform: scale(0.98);
  }

  /* Ensure proper horizontal alignment */
  .item > * {
    flex-shrink: 0;
    box-sizing: border-box;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .item {
    width: 100%;
    min-width: 800px;
    max-width: none;
    padding: 10px 6px;
    height: auto;
    min-height: 52px;
    gap: 6px;
    box-sizing: border-box;
  }

  .item.headers {
    padding: 14px 6px;
    font-size: 11px;
    font-weight: 700;
    width: 100%;
    min-width: 800px;
    max-width: none;
  }

  .notifications {
    flex: 1.5;
    padding: 3px 6px;
    font-size: 12px;
    line-height: 15px;
    min-height: 22px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .notifications.property {
    flex: 0.5;
    padding-left: 6px;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.type {
    flex: 0.5;
    font-size: 11px;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.date,
  .notifications.time {
    flex: 0.5;
    font-size: 11px;
    min-width: 0;
    max-width: 100%;
  }

  .notifications.status {
    flex: 0 0 50px;
    min-width: 50px;
    max-width: 50px;
  }

  .notifications.status img {
    width: 22px;
    height: 22px;
  }

  .notifications.edit,
  .notifications.delete {
    flex: 0 0 36px;
    padding: 6px;
    min-width: 36px;
    max-width: 36px;
    min-height: 36px;
    margin-left: -16px;
  }

  .notifications.edit img,
  .notifications.delete img {
    width: 18px;
    height: 18px;
  }

  /* Enhanced empty state for small mobile */
  .empty-notification-screen {
    padding: 30px 16px;
    margin: 12px;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .empty-notification-screen img {
    width: 30%;
    margin-bottom: 16px;
  }

  .empty-notification-screen div {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .empty-notification-screen button {
    height: 40px;
    font-size: 15px;
    border-radius: 4px;
    max-width: 180px;
  }

  /* Enhanced mobile accessibility */
  .notifications.status,
  .notifications.edit,
  .notifications.delete,
  .empty-notification-screen button {
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* Mobile-optimized shadows */
  .empty-notification-screen {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  /* Ensure proper horizontal alignment */
  .item > * {
    flex-shrink: 0;
    box-sizing: border-box;
  }
}
</style>
